import { message, Select, Spin, Tag } from "antd";
import React, { Component } from "react";
import axios from "axios";
import debounce from "lodash.debounce";
import moment from "moment";
import { connect } from "react-redux";
import { ModalItem, dineroDisabledMask } from "../../../../Components/Items";

const { Option } = Select;

const ESTADOS_COTIZACION = {
  0: { color: "red", texto: "Cancelada" },
  1: { color: "blue", texto: "Vigente" },
  2: { color: "blue", texto: "Pendiente" },
  3: { color: "green", texto: "Venta" },
  4: { color: "green", texto: "Pedido" },
  7: { color: "orange", texto: "Vencida" },
};

class LigarCotizacion extends Component {
  state = {
    opciones: [],
    cargando: false,
    cotizacionIdSeleccionada: null,
    cotizacionSeleccionada: null,
    confirmLoading: false,
  };

  buscarCotizaciones = debounce((texto) => {
    this.setState({ cargando: true });
    axios
      .post(
        "cotizaciones/selectCotizaciones",
        {
          empresaId: this.props.empresaId,
          valor: 1,
          page: 1,
          pageSize: 20,
          textoFiltro: texto,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({ opciones: res.data.data || [] });
        } else {
          this.setState({ opciones: [] });
        }
      })
      .catch(() => {
        this.setState({ opciones: [] });
      })
      .finally(() => {
        this.setState({ cargando: false });
      });
  }, 300);

  componentDidUpdate(prevProps) {
    if (this.props.visible && !prevProps.visible) {
      this.setState({ cotizacionIdSeleccionada: null, cotizacionSeleccionada: null, opciones: [] });
      this.buscarCotizaciones("");
    }
  }

  nombreCliente(cliente) {
    if (!cliente) return "";
    return cliente.persona
      ? cliente.razonSocial || ""
      : `${cliente.nombre || ""} ${cliente.apellidoPaterno || ""} ${cliente.apellidoMaterno || ""}`.trim();
  }

  seleccionar(value) {
    const cotizacion = this.state.opciones.find((op) => op._id === value) || null;
    this.setState({ cotizacionIdSeleccionada: value, cotizacionSeleccionada: cotizacion });
  }

  ligar() {
    if (!this.state.cotizacionIdSeleccionada) {
      return message.warning("Selecciona una cotización");
    }
    this.setState({ confirmLoading: true });
    axios
      .post(
        "preCotizacionIngenieria/ligarCotizacion",
        {
          empresaId: this.props.empresaId,
          preCotizacionId: this.props.preCotizacionId,
          cotizacionId: this.state.cotizacionIdSeleccionada,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ confirmLoading: false });
        if (res.data.success === 2) {
          message.success("Cotización ligada");
          this.props.onCerrar(true);
        } else {
          message.error("No se pudo ligar la cotización");
        }
      });
  }

  render() {
    const { cotizacionSeleccionada } = this.state;
    const estadoInfo = cotizacionSeleccionada ? ESTADOS_COTIZACION[cotizacionSeleccionada.estado] : null;

    return (
      <ModalItem
        title="Ligar Cotización"
        visible={this.props.visible}
        onCancel={() => this.props.onCerrar(false)}
        onOk={this.ligar.bind(this)}
        okText="Ligar"
        cancelText="Cancelar"
        confirmLoading={this.state.confirmLoading}
        footer
      >
        <Select
          showSearch
          allowClear
          filterOption={false}
          placeholder="Busca por folio o cliente"
          style={{ width: "100%" }}
          loading={this.state.cargando}
          notFoundContent={
            this.state.cargando ? (
              <div style={{ textAlign: "center", padding: "8px" }}>Buscando cotizaciones...</div>
            ) : (
              "No se encontraron cotizaciones"
            )
          }
          onSearch={this.buscarCotizaciones}
          onChange={(value) => this.seleccionar(value)}
          value={this.state.cotizacionIdSeleccionada}
          dropdownRender={(menu) => <Spin spinning={this.state.cargando}>{menu}</Spin>}
        >
          {this.state.opciones.map((cotizacion) => (
            <Option key={cotizacion._id} value={cotizacion._id}>
              {`${cotizacion.cotizacionSerie || ""} ${cotizacion.cotizacionNumero || ""} - ${this.nombreCliente(
                cotizacion.cliente
              )}`}
            </Option>
          ))}
        </Select>

        {cotizacionSeleccionada && (
          <div
            style={{
              marginTop: 16,
              padding: "14px 16px",
              borderRadius: 10,
              border: "1px solid #eee",
              background: "linear-gradient(180deg, #fafcff 0%, #f5f7fa 100%)",
              boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
            }}
          >
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10 }}>
              <span style={{ fontSize: 15, fontWeight: 700, color: "#00BFD6" }}>
                {cotizacionSeleccionada.cotizacionSerie} {cotizacionSeleccionada.cotizacionNumero}
              </span>
              {estadoInfo && (
                <Tag color={estadoInfo.color} className="square-tag">
                  {estadoInfo.texto}
                </Tag>
              )}
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", rowGap: 6, columnGap: 12, fontSize: 13 }}>
              <div>
                <span style={{ color: "#999" }}>Cliente:</span>{" "}
                <strong>{this.nombreCliente(cotizacionSeleccionada.cliente) || "—"}</strong>
              </div>
              <div>
                <span style={{ color: "#999" }}>Total:</span>{" "}
                <strong>{dineroDisabledMask(cotizacionSeleccionada.total || 0)}</strong>
              </div>
              <div>
                <span style={{ color: "#999" }}>Fecha:</span>{" "}
                <strong>
                  {cotizacionSeleccionada.createdAt
                    ? moment(cotizacionSeleccionada.createdAt).format("DD/MM/YYYY")
                    : "—"}
                </strong>
              </div>
              <div>
                <span style={{ color: "#999" }}>Proyecto:</span>{" "}
                <strong>{cotizacionSeleccionada.proyecto?.nombre || "—"}</strong>
              </div>
            </div>
          </div>
        )}
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(LigarCotizacion);
